import { render, staticRenderFns } from "./BottomWrapper.vue?vue&type=template&id=6ddb3f7b"
import script from "./BottomWrapper.vue?vue&type=script&lang=ts"
export * from "./BottomWrapper.vue?vue&type=script&lang=ts"
import style0 from "./BottomWrapper.vue?vue&type=style&index=0&id=6ddb3f7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports